import { isValidPublicId } from '@/lib/public-id';

/**
 * Phase 118 shared URL builder for every /w/:ws/* navigate, Link, test goto.
 *
 * Single source of truth for the workspace-scoped URL shape. Production code
 * and tests MUST route through this helper -- this way a future rename
 * (e.g. /w/ → /workspace/) is a single-file change, and a caller that
 * accidentally threads an internal UUID or undefined into a URL string will
 * throw loudly at runtime instead of silently rendering /w/undefined/* or
 * /w/<UUID>/* (which would both cascade into router catch-alls + confusing
 * blank screens).
 *
 * `ws` is validated against the `ws_` publicId shape from
 * `@/lib/public-id#isValidPublicId` (frontend-local mirror of the backend
 * regex -- see 117-03 commentary in that file).
 */
export function workspaceUrl(ws: string, sub?: string): string {
  if (!isValidPublicId(ws, 'ws')) {
    throw new TypeError(`workspaceUrl: invalid ws publicId "${ws}"`);
  }
  if (!sub) return `/w/${ws}`;
  return `/w/${ws}/${sub.replace(/^\/+/, '')}`;
}
